import React from "react";
import { Box } from "lucide-react";

const columns = [
  {
    title: "Workspace Products",
    links: ["FullContainer™", "SmartContainer™", "CommodityBid™", "RFQ™"],
  },
  {
    title: "Platform",
    links: ["FreightIQ™", "Inspection™", "Live Shipment Tracking™", "Document Hub"],
  },
  {
    title: "Company",
    links: ["About DeMaxtore", "Verified Manufacturers", "Security", "Contact"],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-slate-200 bg-slate-50/60">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink text-white">
                <Box className="h-4 w-4" />
              </span>
              <span className="font-display text-[15px] font-extrabold tracking-tight text-ink">
                DeMaxtore
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slateink">
              The enterprise Workspace for factory-direct full container procurement from verified
              Turkish manufacturers.
            </p>
          </div>

          {columns.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-ink">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      className="text-sm text-slateink transition-colors hover:text-demax"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} DeMaxtore. FullContainer™ is a Workspace Product of the
            DeMaxtore platform.
          </p>
          <div className="flex items-center gap-6 text-xs text-slate-400">
            <a href="#top" className="hover:text-ink">Privacy</a>
            <a href="#top" className="hover:text-ink">Terms</a>
            <a href="#top" className="hover:text-ink">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
